import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { ForgotPasswordPage } from "@Screens/Login/ForgotPasswordPage"
import { MailSentPage } from "@Screens/Login/MailSentPage"
import { ForgotPasswordCodePage } from "@Screens/Login/ForgotPasswordCodePage"
import { PasswordCreateForm } from "@Screens/Login/PasswordCreateForm"
import { PasswordChangeSuccess } from "@Screens/Login/PasswordChangeSuccess"
import LoginPage from "@Screens/Login/LoginPage"

const LoginStackNavigator = createNativeStackNavigator()

const LoginStack = () => {
    return (
        <LoginStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            initialRouteName="Login"
        >
            <LoginStackNavigator.Screen name="Login" component={LoginPage} />
            <LoginStackNavigator.Screen name="Forgot-password" component={ForgotPasswordPage} />
            <LoginStackNavigator.Screen name="Mail-sen-for-pwd-reset" component={MailSentPage} />
            <LoginStackNavigator.Screen name="PasswordForgotCode" component={ForgotPasswordCodePage} />
            <LoginStackNavigator.Screen name="PasswordCreateForm" component={PasswordCreateForm} />
            <LoginStackNavigator.Screen name="PasswordChangedSuccess" component={PasswordChangeSuccess} />
        </LoginStackNavigator.Navigator>
    )
}

export default LoginStack
